import { useQuery } from "@apollo/client";

import { graphql } from "~/gql";
import { useAuth } from "../use-auth";

export const USER_DATA_QUERY = graphql(/* GraphQL */ `
  query CurrentUserFeeEarnerData {
    currentUserFeeEarnerData {
      feeEarnerLevelId
      practiceAreaId
      userId
      displayName
      restrictedGpmVisible
      practiceAreaName
      feeEarnerLevelDescription
      currencyId
      organisationalUnitId
      officeLocationId
      quickUpdateShownAt
      feeEarnerId
      officeLocationName
    }
  }
`);

export const useCurrentUserData = (args: { cache: boolean; skip?: boolean }) => {
  const currentUser = useAuth();
  const { data, loading } = useQuery(USER_DATA_QUERY, {
    fetchPolicy: args.cache ? "cache-first" : "no-cache",
    skip: args.skip,
    onError: (error) => {
      console.error("error", error);
    },
  });

  return {
    currentUser: data?.currentUserFeeEarnerData ?? null,
    permissions: currentUser.currentUser?.permissions,
    auth0User: currentUser.currentUser,
    loading,
  };
};
